<template>
  <v-dialog
    v-model="isOpen"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="text-h5">
        Загрузка файлов
      </v-card-title>
      <v-card-text>
        <div class="py-4 text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
            class="mb-4"
          />
          <div class="text-body-1">
            {{ uploadMessage }}
          </div>
          <div class="text-body-2 mt-2 grey--text">
            Пожалуйста, не покидайте страницу
          </div>
          <div v-if="uploadProgress" class="mt-4">
            <v-progress-linear
              :value="uploadProgress"
              color="primary"
              height="8"
              rounded
            />
            <div class="text-caption mt-1">
              {{ uploadProgress }}%
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LKPublicationsFormdataUploadModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Файл загружается',
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    uploadMessage() {
      return this.message
    },
    uploadProgress() {
      return this.progress > 0 ? this.progress : null
    },
  },
}
</script>

<style scoped>
.v-card__title {
  word-break: break-word;
}
</style>
